import { render, staticRenderFns } from "./YoutubeSlide.vue?vue&type=template&id=131457d2"
import script from "./YoutubeSlide.vue?vue&type=script&lang=js"
export * from "./YoutubeSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('131457d2')) {
      api.createRecord('131457d2', component.options)
    } else {
      api.reload('131457d2', component.options)
    }
    module.hot.accept("./YoutubeSlide.vue?vue&type=template&id=131457d2", function () {
      api.rerender('131457d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/player/layerContent/YoutubeSlide.vue"
export default component.exports